import React, { FC } from "react";
import { Chip, Stack, Typography } from "@mui/material";
import CustomSwitch from "@components/CustomSwitch";
import { useTranslation } from "react-i18next";
import { Period } from "@service/subscription/subscription.service";

const BillingPeriodSwitch: FC<{
  onChange: (period: Period) => void;
  value: Period;
}> = ({ onChange, value }) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={1}
    >
      <Typography>{t("subscription.periodSwitch.monthly")}</Typography>
      <CustomSwitch
        checked={value === "year"}
        onChange={(_, checked) => onChange(checked ? "year" : "month")}
      />
      <Typography>{t("subscription.periodSwitch.annual")}</Typography>

      <Chip
        color="primary"
        label={t("subscription.periodSwitch.chipLabel")}
        size="small"
      />
    </Stack>
  );
};

export default BillingPeriodSwitch;
